import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const AboutPage: React.FunctionComponent = () => {
	return (
		<div className="AboutPage noselect">
			<div className="Page-navbar w3-bar w3-top">
				<Link to="/" className="w3-bar-item w3-button w3-left">
					<FontAwesomeIcon
						icon={faArrowLeft}
						className="Page-navbar-icon"
					/>
				</Link>
			</div>

			<div className="Page-content w3-container">
				<h2 className="w3-center">
					<img
						src="/biglogo.svg"
						className="WelcomePage-logo"
						alt="#tagman"
					/>
				</h2>
				<h1>What is it all about?</h1>
				<p>
					Have you searched and collected the perfect set of tags to
					use in your Instagram posts? If yes, do you use a simple
					text document or a note app to manage them, having to
					copy/paste tags together manually, for every post? Quite
					cumbersome, isn't it?
				</p>
				<p>
					This is the idea of <em>#tagman</em>:
				</p>
				<p>
					A small app where you save your carefully collected tags as
					before, but then are able to select the best tags for your
					post in seconds!
				</p>
				<p>
					The app just presents a list of your tags selectable by
					touch. As soon as you have marked all the tags you want, you
					press "Copy" and the list lands in clipboard, ready for
					pasting into your post's text in Instagram. Quick and easy!
				</p>
				<h2>What is it NOT about?</h2>
				<p>
					<em>#tagman</em> does not search for the best Instagram tags
					for you. It doesn't present most successful tags that will
					guarantee millions of likes on your posts. This collection
					is created by yourself, but <em>#tagman</em>&nbsp;helps to
					work with this collection afterwards.
				</p>
			</div>
		</div>
	);
};

export default AboutPage;
